
import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from './Icon.vue'

@Component({
  components: { Icon }
})
export default class ToggleButton extends Vue {
  @Prop({}) selected!: boolean
  @Prop({}) disabled!: boolean
  @Prop({}) icon!: string
}
